module.exports = __webpack_public_path__ + "media/images/course/terminal-834e9d384756cb01d00d48f522cb36c0.png";